import React from "react";
import { Text, FormFieldTextProps } from "./Text";

export interface FormFieldFloatProps
  extends Omit<FormFieldTextProps, "inputType" | "onChangeField"> {
  step?: number;
  onChangeField: (id: string, value: number | null) => void;
}

export const Float: React.FC<FormFieldFloatProps> = ({
  onChangeField,
  id,
  step = 0.01,
  ...props
}) => {
  const handleChange = (fieldId: string, value: string | null) => {
    if (value === null || value === "") {
      onChangeField(fieldId, null);
      return;
    }
    const parsed = parseFloat(value);
    onChangeField(fieldId, isNaN(parsed) ? null : parsed);
  };

  return (
    <Text
      {...props}
      id={id}
      onChangeField={handleChange as any}
      value={props.value != null ? String(props.value) : null}
      inputType="number"
    />
  );
};

Float.displayName = "FormField.Float";
